import { render, staticRenderFns } from "./DemoDate.vue?vue&type=template&id=e79816d6"
import script from "./DemoDate.vue?vue&type=script&lang=js"
export * from "./DemoDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports